/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc DOM関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
export default new class {
  /**
   * 対象ノードが末尾までスクロール（Y軸）されてるか
   * @param  {HTMLElement} htmlElement 対象ノード
   * @return {Boolean}
   */
  isLastScrollY(htmlElement) {
    const scrollTop = htmlElement.scrollTop
    const height = htmlElement.offsetHeight
    const scrollHeight = htmlElement.scrollHeight
    return (scrollTop + height) >= scrollHeight
  }
}()



// WEBPACK FOOTER //
// ./src/utils/DomUtil.js